<template>
  <div class="container">
    <div class="row">
      <h5 class="reassignment-header">{{ reassignmentHeader }}</h5>

    </div>
    <div class="row">
      <div class="amf-primitive three-column three">
        <user-search :onSelectUser="onSelectUser" label="User" :autofocus="true" :validator="$v.selectedUser">
        </user-search>
        <a class="btn btn-success text-white mt-3" v-if="showAssignToMeButton" @click="assignToMe">Assign to Me</a>
        <a class="btn btn-success text-white mt-3" v-if="showUnassignMeButton" @click="resetAssignmentInternal" title="">Reset Assignment</a><br/>
      </div>
      <amf-select
        label="Role"
        v-model="selectedRoleId"
        caption="--Select Role--"
        v-on:input="onSelectRole"
        :options="roles"
        :columns="3"
        :validator="$v.selectedRoleId"
      />

    </div>
    <div>
      <div :columns="6" v-if="showReassignmentBox" class="alert alert-info">Reassigning to {{reassignmentText}}</div>
    </div>
  </div>
</template>

<script>
import store from '../store';
import { actionItemUserRoles } from '../user/user-labels.js';
import UserSearch from "../shared/UserSearch";

export default {
  components: { UserSearch },
  props: ["actionItem"],
  data() {
    return {
        buttons: "Save/Cancel",
        title: "Reassign Action Item",
        selectedUser: null,
        selectedRoleId: null,
        lastAssignedUserId: null,
        lastAssignedUserName: null,
    };
  },
  inject: ['closeModal'],
  computed:{
      ...amfx.map("actionItems", ["items", "selectedItems", "currentSearchParams"]),
      ...amfx.map("session", ["user"]),
      roles() {
        let ais = this.items.filter(x => this.selectedItems.includes(x.actionItemId) || (this.actionItem && this.actionItem.actionItemId == x.actionItemId));
        let anyIsCustom = ais.some(x => x.itemType.startsWith("custom-"));
        let aiRoles = actionItemUserRoles.filter(x => x.assignable);

        if (anyIsCustom) {
          aiRoles = aiRoles.filter(x => !x.isExternal);
        }

        return _.sortBy(aiRoles, r => r.name);
      },
      showReassignmentBox() {
        return (this.selectedUser || this.selectedRoleId) && !(this.selectedUser && this.selectedRoleId);
      },
      roleName() {
        return this.roles.find(x => x.id === this.selectedRoleId).name;
      },
      reassignmentText() {
        return this.selectedUser ? this.selectedUser.displayName : this.roleName;
      },
      reassignmentHeader() {
        if (this.selectedItems && this.selectedItems.length > 0) {
          return `You are reassigning ${this.selectedItems.length} Action Item${this.selectedItems.length === 1 ? '' : 's'}`;
        }

        return 'You are reassigning 1 Action Item';
      },
      showAssignToMeButton() {
        if (this.actionItem && this.actionItem.assignments) {
          return !this.actionItem.assignments.some(x => x.userId === this.user.userId);
        }

        if (this.selectedItems && this.selectedItems.length > 0) {
          return true;
        }

        return false;
      },
      showUnassignMeButton() {
        if (!this.actionItem || !this.actionItem.assignments) return false;
        return true;
      },
      showAssignQaButton() {
        if (!this.actionItem) return false;
        return this.actionItem.itemType.startsWith('custom-') && !this.actionItem.assignments.some(x => x.roleName);
      }
  },
  methods: {
      ...amfx.map("actionItems", ["assignToUser", "assignToRole","batchAssignToUser", "batchAssignToRole","resetAssignment","refresh"]),
      onSelectUser(result) {
        if (result !== null) {
          this.selectedUser = result;
          this.selectedRoleId = null;
        }
      },
      onSelectRole(val) {
        if (val !== null) {
          this.selectedRoleId = val;
          this.selectedUser = null;
        }
      },
      async close() {
        this.closeModal();
      },
      async assignToMe() {
        if (this.actionItem) {
          await this.assignToUser({ actionItemId: this.actionItem.actionItemId, userId: this.user.userId, assignmentText: this.user.firstName + ' ' + this.user.lastName });
        } else if (this.selectedItems && this.selectedItems.length > 0) {
          await this.batchAssignToUser(this.user.userId);
        }
        toastService.success(`Action Item(s) assigned to ${this.user.fullName}`);
        await this.close();
      },
      async resetAssignmentInternal() {
        await this.resetAssignment({ actionItemId: this.actionItem.actionItemId });
        toastService.success('Action item assignment reset');
        await this.close();
      },
      async save() {
        if (this.selectedItems && this.selectedItems.length && this.selectedUser) {
          await this.batchAssignToUser(this.selectedUser.id);
        } else if (this.selectedItems && this.selectedItems.length && this.selectedRoleId) {
          await this.batchAssignToRole(this.selectedRoleId);
        } else if (this.selectedUser) {
          await this.assignToUser({ actionItemId: this.actionItem.actionItemId, userId: this.selectedUser.id, assignmentText: this.selectedUser.displayName });
        } else if (this.selectedRoleId) {
          await this.assignToRole({ actionItemId: this.actionItem.actionItemId, roleId: this.selectedRoleId, assignmentText: this.reassignmentText });
        }
        toastService.success(`Action Item(s) assigned to ${this.reassignmentText}`);
        await this.refresh();
        await this.close();
      }
  },
  async created() {
    if (this.selectedItems && this.selectedItems.length) return;
    var lastAssignedInfo = await romeApi.get(`/actionitem/v-2/${this.actionItem.actionItemId}/lastassigneduser`);
    if (!!lastAssignedInfo) {
      this.lastAssignedUserId = lastAssignedInfo.assignedToUserId;
      this.lastAssignedUserName = lastAssignedInfo.assignedToUserName;
    }
  },
  validations() {
    return {
      selectedUser:
        v.build(
          v.custom(user => {
            if (!user && !this.selectedRoleId) return false;
            return true;
          }, "Either a user or role must be selected")
        ),
      selectedRoleId:
        v.build(
          v.custom(roleId => {
            if (!roleId && !this.selectedUser) return false;
            return true;
          }, "Either a user or role must be selected"),
        )
    }
  }
};
</script>

<style lang="scss" scoped>
.reassignment-header {
  padding-left: 15px;
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/action-items/ActionItemAssignmentModal.vue